module.exports = __webpack_public_path__ + "img/dropdown.59b9498e.svg";